import React from "react";
import { Page } from "components/ui/Page";
import { Route, Routes } from "react-router-dom";
import { CampusRedirect } from "./CampusPage/CampusRedirect";
import { CampusLoading } from "./CampusPage/CampusLoading";
import { CampusCardTitle } from "./CampusPage/CampusCardTitle";
import { CampusSidebar } from "./CampusPage/CampusSidebar";
import { CampusLinksCard } from "../cards/CampusLinksCard";
import { PageColumn, CampusLayout } from "../ui/PageColumns";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+My+Campus+Page
export default function CampusPage() {
  return (
    <Routes>
      <Route path="" element={<CampusPageContent />} />
      <Route path=":categoryId" element={<CampusPageContent />} />
    </Routes>
  );
}

function CampusPageContent() {
  return (
    <Page>
      <CampusLoading />
      <CampusRedirect />

      <CampusLayout>
        <PageColumn style={{ paddingTop: `var(--md)` }}>
          <CampusCardTitle />
          <CampusLinksCard />
        </PageColumn>
        <PageColumn style={{ order: `-1` }}>
          <CampusSidebar />
        </PageColumn>
      </CampusLayout>
    </Page>
  );
}
